import type { Application } from '@src/@types/app';
import { MODES } from '@src/constants/filters';
import { getHasUtmLabel } from '@src/reducers/route';

export const getFilterMode = (ctx: Application.ReduxNextPageContext, isSEAOffersLimitExperimentActive: boolean) => {
  const hasUtmLabel = getHasUtmLabel(ctx.store.getState());

  let filterMode = MODES.DEFAULT;

  if (hasUtmLabel) {
    if (isSEAOffersLimitExperimentActive) {
      filterMode = MODES.AS_UTM_SEA_OFFERS_LIMIT;
    } else {
      filterMode = MODES.AS_UTM;
    }
  }

  return filterMode;
};
